export const skillsData = {
    frontend: {
        title: "Frontend Development",
        icon: null,
        skills: [
            { name: "React.js", level: 90, experience: "3+ years", icon: "⚛️" },
            { name: "JavaScript (ES6+)", level: 95, experience: "3+ years", icon: "🟨" },
            { name: "TypeScript", level: 85, experience: "2+ years", icon: "🔷" },
            { name: "HTML5 & CSS3", level: 95, experience: "3+ years", icon: "🎨" },
            { name: "Tailwind CSS", level: 90, experience: "2+ years", icon: "🎨" },
            { name: "Next.js", level: 20, experience: "2+ years", icon: "▲" },
            { name: "Redux", level: 50, experience: "2+ years", icon: "🔄" },
            { name: "Material-UI", level: 80, experience: "2+ years", icon: "🎯" }
        ]
    },
    backend: {
        title: "Backend Development",
        icon: "⚙️",
        skills: [
            { name: "Node.js", level: 50, experience: "3+ years", icon: "🟢" },
            { name: "Python", level: 85, experience: "3+ years", icon: "🐍" },
            { name: "Java", level: 80, experience: "2+ years", icon: "☕" },
            { name: "Spring Boot", level: 70, experience: "2+ years", icon: "🍃" },
            { name: "Flask", level: 80, experience: "2+ years", icon: "🌶️" },
            { name: "RESTful APIs", level: 95, experience: "3+ years", icon: "🔗" },
        ]
    },
    database: {
        title: "Database & Cloud",
        icon: "🗄️",
        skills: [
            { name: "MongoDB", level: 90, experience: "3+ years", icon: "🍃" },
            { name: "MySQL", level: 85, experience: "2+ years", icon: "🐬" },
            { name: "PostgreSQL", level: 20, experience: "2+ years", icon: "🐘" },
            { name: "AWS", level: 75, experience: "1+ years", icon: "☁️" },
            { name: "Firebase", level: 85, experience: "2+ years", icon: "🔥" },
        ]
    },
    tools: {
        title: "Tools & Technologies",
        icon: "🛠️",
        skills: [
            { name: "Git & GitHub", level: 95, experience: "3+ years", icon: "📚" },
            { name: "VS Code", level: 95, experience: "3+ years", icon: "💙" },
            { name: "Postman", level: 90, experience: "3+ years", icon: "📮" },
            { name: "Figma", level: 75, experience: "2+ years", icon: "🎨" },
            { name: "Jira", level: 80, experience: "2+ years", icon: "📋" },
        ]
    },
    learning: {
        title: "Currently Learning",
        icon: "📚",
        skills: [
            { name: "React Native", level: 45, experience: "Learning", icon: "📱" }
        ]
    }
};
